import { Card, Divider } from "@mui/material";
import type {
  FindUserReservationsFlightReservation,
  FindUserReservationsHotelReservation,
} from "../lib/types/codegen";
import { OrderLabel } from "./my-bookings/OrderLabel";
import { formatCurrency } from "../lib/utils/currency";
import { useTranslations } from "use-intl";
import dayjs from "dayjs";

type Props = {
  reservation:
    | FindUserReservationsFlightReservation
    | FindUserReservationsHotelReservation;
  onClick?: () => void;
};

export const OrderCardWithoutReservation = ({
  reservation,
  onClick,
}: Props) => {
  const t = useTranslations();
  return (
    <Card
      className="flex flex-col gap-4 p-4"
      onClick={onClick}
      sx={{
        borderRadius: "var(--radius-3xl)",
      }}
      elevation={0}
    >
      <div className="flex w-full justify-between">
        <span>
          {`${t("reservations.bookedAt")}: ${dayjs(reservation.createdAt).format("DD MMM, YYYY")}`}
        </span>

        <OrderLabel status={reservation.status} />
      </div>
      <Divider />
      <div className="flex flex-wrap items-center justify-between gap-2">
        <span>{`${t("reservations.id")}: ${reservation.id}`}</span>
        <div className="grow text-end">
          <strong>
            {formatCurrency(reservation.price, reservation.currency)}
          </strong>
        </div>
      </div>
    </Card>
  );
};
